import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DataReactTable from './components/DataReactTable';


const PendingTable = () => (
  <div>
    <Container>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
        marginLeft: '15px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Payment</Typography>
        <Typography sx={{ color: 'text.primary' }}>Pending</Typography>
      </Breadcrumbs>
      <Row>
        <Col md={12} />
      </Row>
      <Row>
        <DataReactTable />
      </Row>
    </Container>
  </div>
  
  );

export default PendingTable;

